// extracted by mini-css-extract-plugin
module.exports = {"empty":"Empty_empty__QnYXC"};